import styled from '@emotion/styled';
import { Button, Drawer, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';
import { Content, Container, Footer } from '../../compound/Drawer';
import LoadingButton from '../LoadingButton';

export const StyledDrawer = styled(Drawer)(``);

export const DrawerContainer = styled(Container)(``);

export const DrawerContent = styled(Content)(``);

export const DrawerFooter = styled(Footer)(``);

export const DrawerButton = styled(LoadingButton)(`
  color: #FFFFFF;
  width: 128px;
  height: 32px;
  font-size: 14px;
  background: ${COLOR_TEXT_MAIN};
  font-weight: 800;
  border-color: ${COLOR_TEXT_MAIN};
  border-radius: 4px;
  :hover {
    background: #707889;
    border-color: #707889;
  }
  :disabled {
    background: #E6E7E8;
    color: rgba(75, 85, 106, 0.24);
    border: rgba(75, 85, 106, 0.24);
  }
`);

export const DrawerCancelButton = styled(Button)(`
  color: ${COLOR_TEXT_MAIN};
  width: 128px;
  height: 32px;
  font-size: 14px;
  background: #FFFFFF;
  font-weight: 800;
  border: 1.5px solid #E6E7E8;
  border-radius: 4px;
  margin-right: 16px;
  :hover {
    background: #FFFFFF;
  }
`);

export const DrawerTitle = styled(Typography)(`
  font-weight: 700;
  font-size: 24px;
  color: ${COLOR_TEXT_MAIN};
`);

export const DrawerHeader = styled('div')(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`);
